import { ModelYearSubPageName, } from '../types';
import { LinkType } from '../../../core/types';
import { PaymentMethod } from '../constants';
function toLowercase(str) {
    return str.toLowerCase();
}
const getTrimFinancials = (trim) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const bonusOffers = [
        {
            paymentMethod: PaymentMethod.cash,
            offers: trim.cashBonusOffers.items,
        },
        {
            paymentMethod: PaymentMethod.finance,
            offers: trim.financeBonusOffers.items,
        },
        {
            paymentMethod: PaymentMethod.lease,
            offers: trim.leaseBonusOffers.items,
        },
    ];
    return {
        bonusOffers,
        defaultFinancePaymentFrequency: (_a = toLowercase(trim.defaultFinancePaymentFrequency.value)) !== null && _a !== void 0 ? _a : '',
        defaultFinancePaymentTerm: (_b = trim.defaultFinancePaymentTerm.value) !== null && _b !== void 0 ? _b : '',
        defaultLeasePaymentFrequency: (_c = toLowercase(trim.defaultLeasePaymentFrequency.value)) !== null && _c !== void 0 ? _c : '',
        defaultLeasePaymentTerm: (_d = trim.defaultLeasePaymentTerm.value) !== null && _d !== void 0 ? _d : '',
        defaultPaymentMethod: (_e = toLowercase(trim.defaultPaymentMethod.value)) !== null && _e !== void 0 ? _e : '',
        financeDownPayment: (_f = trim.financeDownPayment.value) !== null && _f !== void 0 ? _f : '',
        leaseDownPayment: (_g = trim.leaseDownPayment.value) !== null && _g !== void 0 ? _g : '',
    };
};
const getAllTrims = (modelItem) => {
    const modelName = modelItem.modelName.value;
    const modelYears = modelItem === null || modelItem === void 0 ? void 0 : modelItem.modelYears;
    const modelKey = modelItem.detKey.value;
    return modelYears.flatMap(modelYear => {
        var _a, _b, _c;
        const year = modelYear.year.value;
        const trims = modelYear === null || modelYear === void 0 ? void 0 : modelYear.trims;
        const exploreCtaHrefBase = ((_c = (_b = (_a = modelYear === null || modelYear === void 0 ? void 0 : modelYear.modelYearPage) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.subPages.find(({ name }) => name === ModelYearSubPageName.TRIMS)) === null || _c === void 0 ? void 0 : _c.url) || '';
        const allTrims = trims.map(trim => {
            var _a, _b, _c;
            const trimKey = trim.detKey.value;
            const trimName = trim.trimName.value;
            const primaryThumbnail = trim.primaryThumbnail.item;
            const secondaryThumbnail = trim.secondaryThumbnail.item;
            const defaultTransmission = trim.defaultTransmission.item;
            const defaultExteriorColor = defaultTransmission.defaultExteriorColor.item;
            const exteriorColorKey = (_a = defaultExteriorColor.color.item) === null || _a === void 0 ? void 0 : _a.detKey.value;
            const interiorColorKey = (_b = defaultExteriorColor.defaultInteriorColor.interiorColor.color.fields) === null || _b === void 0 ? void 0 : _b.detKey.value;
            return {
                modelName,
                modelKey,
                modelYear: year,
                trimKey,
                trimName,
                transmissionKey: defaultTransmission.detKey.value,
                exteriorColorKey,
                interiorColorKey,
                image: (_c = primaryThumbnail.value) !== null && _c !== void 0 ? _c : secondaryThumbnail.value,
                financials: getTrimFinancials(trim),
                exploreModelCta: !exploreCtaHrefBase
                    ? undefined
                    : {
                        href: exploreCtaHrefBase,
                        linkType: LinkType.INTERNAL,
                        hrefSearch: `trim=${trimKey}`,
                    },
            };
        });
        return allTrims;
    });
};
export default getAllTrims;
